export default __webpack_public_path__ + "static/media/tab_4.793e7b73.png";